export const createByFieldSorter = <TItem>(fieldName: keyof TItem) => (
  a: TItem,
  b: TItem
) => {
  const prev = a[fieldName];
  const next = b[fieldName];

  if (prev === null) return -1;

  if (next === null) return 1;

  if (prev === next) return 0;

  return prev > next ? 1 : -1;
};
